module.exports = __webpack_public_path__ + "272c653642a6a54ba02d6e2e686547ac.svg";